import React from 'react';
import Login from '../components/auth/Login';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { user } = useAuth();

  // If already logged in, redirect to home
  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;